// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".Skeleton-base__PKCfB{position:relative;display:flex;flex-grow:1}.Skeleton-base__PKCfB>span{display:flex;width:var(--size-full)}.Skeleton-base__PKCfB .react-loading-skeleton{--base-color: var(--gray-4);--highlight-color: var(--gray-2)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"base": "Skeleton-base__PKCfB"
};
export default ___CSS_LOADER_EXPORT___;
